import { render, staticRenderFns } from "./CreatePlatform.vue?vue&type=template&id=5cdf5c1f"
import script from "./CreatePlatform.vue?vue&type=script&lang=js"
export * from "./CreatePlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports